import { render } from "./HeaderCartDropdown.vue?vue&type=template&id=6e079796"
import script from "./HeaderCartDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderCartDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script